import { Injectable, Injector, Query } from "@angular/core";
import { BaseService } from "../base/base.service";
import { HttpClient } from "@angular/common/http";
import { PlatformLocation } from "@angular/common";
import { Observable } from "rxjs";
import { AppModulePath } from "app/models/app-module-path";
import { catchError, map } from "rxjs/operators";
import { KontaktOsoba } from "app/models/lookups/kontaktOsoba";

@Injectable()
export class KontaktOsobaService extends BaseService {

   private listByPartnerUrl = "/api/ko/partner/";


    constructor(
    protected injector: Injector,
    protected http2: HttpClient,
    protected platformLocation: PlatformLocation
  ) {
    super(injector, http2, platformLocation);
  }

  listByPartner(partnerId: string): Observable<KontaktOsoba[]> {
    return this.get<KontaktOsoba[]>(
      this.listByPartnerUrl + partnerId, AppModulePath.DOCUMENT).pipe(
      map(res => res.map(o => new KontaktOsoba(o))),
      catchError(this.handleError)
    );
  }
}